import * as mutationTypes from '@/store/mutation-types.js'
import stringOperations from '@/mixins/string-operations'
import dateOperations from '@/mixins/date-operations'
import kalender from '@/components/utils/kalender/kalender.vue'
import icons from '@/mixins/icons.js'

import Vue from 'vue'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import mmItems from '@/mixins/main-menu-items.js'
import basicOperations from '@/mixins/basic-operations.js'


export default {
  name: 'MijnGebruiker',

  mixins: [stringOperations, dateOperations, icons, mmItems, basicOperations],

  components: {
    kalender
  },

  data() {
    return {
      userdata: {},
      debugging: this.$store.state.debugging,
      changePasswordActive: false,
      linkChildActive: false,
      currentPW: '',
      PW: '',
      PW2: '',
      PWMin8: false,
      PWSpecialChars: false,
      passwordsInfo: [],
      passwordFieldType: 'password',
      rollen: this.$store.state.rollen,
      datumChild: this._formatDateSQL(new Date()),
      datumKalenderId: 'datumKalenderId',
      dateInfo: '',
      Koppelcode: '',
      Rol: null,
      schermen: [],
      selectedScherm: null,
      isOuder: false,
      isLeerling: false,
      isLeerkracht: false,
      Office365LoginAllowed: false,
      Office365LoginExists: false,
      GoogleLoginAllowed: false,
      GoogleLoginExists: false,
      FaceBookLoginAllowed: false,
      FaceBookLoginExists: false,
      returnLink: encodeURI(JSON.stringify({
        "linkreturn": true
      })),
      url: window.location.href.split('/Agenda')[0],
      serverLocation: null,
      isAndroidOrIOS: this._isAndroidOrIOS(),
      children: []
    }
  },

  computed: {
    nameOfUser() {
      return this._capitalizeFirstLetters(
        this.$store.state.userInfo.loggedInUserInformation.UserData.name
      )
    }
  },

  // v-on:keyup="checkIfRecChanged"
  watch: {
    selectedScherm: function (newVal, oldVal) { // watch it

      //var geselecteerdScherm = 'NietBepaald'
      if (newVal !== null) {
        this._checkUserPrefsInsertOrUpdateIfNeeded('', this, 'MYPROFILE', this.$store.state.profileScherm.ID, 'Window', 'voorkeurscherm', newVal.Scherm)
      }
    }
  },

  mounted: function () {


    this.children = this.$store.state.mainMenuItems.filter(function (item) {
      return item.isStudentForParent
    })
    this.serverLocation = this.$store.state.userInfo.loggedInConnectionObject.serverLocation
    if (this.serverLocation === '..') {
      this.serverLocation = window.location.href.split('vue/')[0]
    }
    this.serverLocation += 'bin/server.fcgi'
    if (window.location.href.indexOf('linkreturn') > -1) {
      this.$store.commit(mutationTypes.SHOW_MESSAGE, ['De koppeling is succesvol verlopen!', 'long'])
    }

    /* Testcases zoeken:

     select LL_ID, LL_NAAM, LL_VOORNAAM, LL_GEBOORTEDATUM, Leerling.LL_KOPPELCODE, leerling.LL_RESTERENDEKOPPELINGEN, IS_CODE, lluser.U_NAAM as leerlinguser
     from inuit
     left join leerling on inuit.IU_LEERLING_FK = LL_ID
     left join users lluser on leerling.LL_USER_FK = lluser.U_ID
     left join school on SC_ID = inuit.IU_SCHOOL_FK
     left join instelling on instelling.IS_SCHOOL_FK = sc_id
     where IU_DATUMUITSCHRIJVING = '30.06.2999'
     and IS_CODE in ('A', 'B')

          // => websiteinstellingen !!!

      Koppeling verwijderen:
      select * from USERKOPPELING order by UK_ID desc
    */

    //if (this.debugging) {
    this.datumChild = this._formatDateSQL(new Date(2002, 1, 27)) // js => maand -1 doen
    this.Koppelcode = 'L7060-72C-C8AF62' // = Ilias Ben Ziane
    this.Rol = {
      label: 'Vader',
      value: 1
    }
    // }

    var links = ''
    if (this.isAndroidOrIOS) {
      links = 'menu'
    }
    this.$store.commit(mutationTypes.SET_MENUBAR_ITEMS, {
      left: 'links',
      title: 'Mijn gebruiker',
      right: []
    })
    this.userdata = this.$store.state.userInfo.loggedInUserInformation.UserData
    console.log('mijn-gebruiker mounted')

    if (this.$store.state.api === '') {
      this.$store.dispatch('apiCheck', {
        dezeDit: this,
        succesCallback: this.vervolgMounted
      })
    } else {
      this.vervolgMounted()
    }

  },

  methods: {

    dateChangedFunction: function (date) {
      console.log('dateChangedFunction')
      this.dateInfo = this._dateValidation(this.datumChild, 'YYYY-MM-DD')
    },

    vervolgMounted: function () {
      this.isLeerkracht = this.$store.state.userInfo.isLeerkracht
      this.isOuder = this.$store.state.userInfo.isOuder
      this.isLeerling = this.$store.state.userInfo.isLeerling
      this.PWMin8 = this.$store.state.api.PWMin8
      this.PWSpecialChars = this.$store.state.api.PWSpecialChars

      if (this.isLeerkracht || this.isLeerling) {
        this.Office365LoginAllowed = this.$store.state.api.Office365Login
        this.GoogleLoginAllowed = this.$store.state.api.GoogleLogin
        this.FaceBookLoginAllowed = this.$store.state.api.FaceBookLogin
        this.$store.dispatch('getExternSystemenEnUsers', this)
      }

      if (this.isLeerkracht) {
        this.schermen = this._voorkeurschermenMetVoldoendeRechtenBepalen();
        this.$store.dispatch('getMyProfileScherm', this)
      }

      // In de WebOuders is de login procedure nog niet doorlopen waardoor kinderen niet gekend zijn:
      if (this.isOuder && (this.$store.state.mainMenuItems === null || this.$store.state.mainMenuItems === undefined || this.$store.state.mainMenuItems.length < 1)) {
        this.$store.dispatch('loginToRetrieveChildren', this)
      }
    },

    externSysteemEnUsersRetrieved: function () {
      console.log('externSysteemEnUsersRetrieved')
      for (var x = 0; x < this.$store.state.externeUsers.length; x++) {
        var huidigeExterneUser = this.$store.state.externeUsers[x];
        var bijhorendExternSysteemRec = this.$store.state.externeSystemen.filter(function (t) {
          return (t.ID === huidigeExterneUser.ExternSysteemID)
        }, this)[0]
        if (bijhorendExternSysteemRec !== null && bijhorendExternSysteemRec !== undefined) {
          // Bestaande koppelingen niet meer tonen
          switch (bijhorendExternSysteemRec.TypeSysteem) {
            case 'Office365':
              this.Office365LoginExists = true;
              break;
            case 'Google':
              this.GoogleLoginExists = true;
              break;
            case 'Facebook':
              this.FaceBookLoginExists = true;
              break;
          }
        }
      }
    },

    linkOffice365() {
      window.location = this.serverLocation + '/oauth2/link/office365?formname=myprofile&formparams=' + this.returnLink;
    },

    linkGoogle() {
      window.location = this.serverLocation + '/oauth2/link/google?formname=myprofile&formparams=' + this.returnLink;
    },

    linkFacebook() {
      window.location = this.serverLocation + '/oauth2/link/facebook?formname=myprofile&formparams=' + this.returnLink;
    },

    editPassword() {
      console.log('oude request oproepen')
      this.changePasswordActive = true
    },

    changePasswordConfirmation() {
      console.log('changePasswordConfirmation')
      this.$store.dispatch('changePasswordConfirmation', this)
    },

    linkChildActivation() {
      this.linkChildActive = true
    },

    linkChild() {
      console.log('linkChild')
      this.$store.dispatch('koppelLeerling', this)
    },

    passwordChanged: function () {
      this.passwordsInfo = this._passwordValidation(this.PW, this.PW2, this.PWMin8, this.PWSpecialChars)
    },

    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },

  }
}
